<div style="display: flex;flex-direction:column;height:100%;" class="loginBg">
    <div style="flex:1 0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;" class="loginOverlay">
        <div class="loginPanel" style="margin-top:30px;">
            <div fxLayout="column" fxLayoutGap="10px">
                <label class="loginLabel">Change Password</label>
                <div class="control" style="padding-top:10px">
                    <label>Current Password</label>
                    <input type="password" class="block" #txtPassword [(ngModel)]="model.OldPassword" (keyUp.enter)="txtNewPassword.focus()" />
                </div>
                <div class="control">
                    <label>New Password</label>
                    <input type="password" class="block" #txtNewPassword [(ngModel)]="model.NewPassword" (keyUp.enter)="txtPasswordConfirm.focus()" />
                </div>
                <div class="control">
                    <label>Confirm Password</label>
                    <input type="password" class="block" #txtPasswordConfirm [(ngModel)]="model.ConfirmNewPassword" (keyUp.enter)="submit()" />
                </div>
                <div class="control">
                    <label>- Password length must be at least 8 characters</label>
                </div>
                <span *ngIf="errorMessage" class="errorText">{{errorMessage}}</span>
                <button md-raised-button type="button" (click)="submit()" color="primary">Change Password</button>
            </div>
        </div>
    </div>
</div>